module.exports = [{"type":"title","text":"2025-03-13"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual USDT-M: Support 'Separated Isolated' Margin"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-03-13.json
// module id = MNmP
// module chunks = 3